import * as actionTypes from "./ActionTypes";
import {
  postRequest,
  getRequest,
  putRequest,
  postRequestFile,
  postRequestVerify,
  loginRequest,
  postResetPass,
} from "../Helper/ApiHit";
import { async } from "q";

//--------------------API LOGIN PAGE DEEPAK -------------------------------------------------------------
export const getLogin = (email, password) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.LOGIN_INITIAL });
    loginRequest("employer/signin", {
      email: email,
      password: password,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          localStorage.setItem("userToken", res.headers.authorization);
          return dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            payload: true,
          });
        } else {
          localStorage.setItem("user", "");
          return dispatch({
            type: actionTypes.LOGIN_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        localStorage.setItem("user", "");
        return dispatch({
          type: actionTypes.LOGIN_FAIL,
          payload: "Server Error,Try Again",
        });
      });
  };
};

//--------------------API LOGIN PAGE DEEPAK -------------------------------------------------------------
export const verifyEmail = (token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.VERIFY_EMAIL_INITIAL });
    getRequest(`candidate/verifyEmail?token=${token}`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.VERIFY_EMAIL_FAIL,
            payload: false,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.VERIFY_EMAIL_FAIL,
          payload: false,
        });
      });
  };
};

//-------------------- API GET SKILLS MASTER JOB PROFILE - DEEPAK ------------------------------------------------------

export const getSkillsMaster = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_SKILLS_INITIAL });
    getRequest(`master/getSkillMaster`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_SKILLS_SUCCESS,
            payload: res.data.responseData.skillList,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_SKILLS_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.GET_SKILLS_FAIL,
          payload: "Server Error",
        });
      });
  };
};

//--------------------API signUP PAGE NIKHIL -------------------------------------------------------------
export const getSignUp = (formData) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.SIGNUP_INITIAL });
    postRequest("employer/signup", formData)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.SIGNUP_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.SIGNUP_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.SIGNUP_EXT_ERROR,
          payload: err.message,
        });
      });
  };
};

//--------------------API MY PROFILE PAGE STATE LISTING ATISHAY-------------------------------------------------------------------------
export const getState = (countryID) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_STATE_INITIAL });
    getRequest("master/getStateByCountryId/" + countryID)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_STATE_SUCCESS,
            payload: res.data.responseData.stateList,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_STATE_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        // console.log(error)
      });
  };
};

//--------------------API MY PROFILE PAGE CITY LISTING ATISHAY-------------------------------------------------------------------------

export const getCity = (stateID) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CITY_INITIAL });
    getRequest("master/getCityByStateId/" + stateID)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_CITY_SUCCESS,
            payload: res.data.responseData.cityList,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_CITY_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        // console.log(error)
      });
  };
};

//--------------------API GET PASSWORD RESET LINK NIKHIL-------------------------------------------------------------------------

export const getForgotPasswordLink = (email, x) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.INTERVIEWER_FORGOT_PASSWORD_INITIAL });
    postRequest("employer/generatePasswordResetToken", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          if (x === 1) {
            return dispatch({
              type: actionTypes.FORGOT_PASSWORD_LINK_SUCCESS,
              email: email,
              resend: false,
            });
          } else {
            return dispatch({
              type: actionTypes.FORGOT_PASSWORD_LINK_SUCCESS,
              email: email,
              resend: true,
            });
          }
        } else {
          return dispatch({
            type: actionTypes.FORGOT_PASSWORD_LINK_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.FORGOT_PASSWORD_NETWORK_ERROR,
        });
      });
  };
};

//--------------------Hide Second Screen coming on click of Forgot Password - Nikhil-------------------------------------------------------------------------
export const changeResetLinkState = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FORGOT_PASSWORD_SECOND_SCREEN_HIDE,
    });
  };
};

//--------------------API UPDATE COMPANY LOCATION Nikhil-------------------------------------------------------------------------
export const getUpdateCompanyLocation = (location) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_COMPANY_LOCATION_INITIAL });
    postRequest(
      "employer/updateCompanyLocation",
      {
        location: location,
      },
      true
    )
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.UPDATE_COMPANY_LOCATION_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.UPDATE_COMPANY_LOCATION_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        //   console.log(err)
      });
  };
};
//--------------------API reset password BRIJESH-------------------------------------------------------------------------
export const getResetPassword = (email, pass, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESET_PASSWORD_INITIAL });
    postResetPass(
      "employer/resetPassword",
      {
        emailId: email,
        password: pass,
      },
      token
    )
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {});
  };
};

//-------------------- API VIEW SINGLE CANDIDATE PROFILE - DEEPAK ------------------------------------------------------

// export const viewSingleCandidateProfile = (id)=>{
//     return (dispatch)=>{
//            dispatch({type:actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_INITIAL});
//            getRequest(`employer/viewCandidateProfile?candidateId=${id}`)
//            .then(res=>{
//             //    console.log(res);
//             if(res.data.responseStatus.statusCode ===0 ){
//         //         const candidateProfileList = res.data.responseData.candidateProfileList==undefined ?[]:res.data.responseData.candidateProfileList
//         //         const data =  candidateProfileList[0]

//         //             const candidateSkills = data.candidateSkills!==null && data.candidateSkills.map(el=> el)
//         //             const candidateOtherSkills = data.candidateOtherSkills!==null && data.candidateOtherSkills.map(el=>el)
//         //             const candidateSkillSelected = [...candidateSkills,...candidateOtherSkills]
//         //             console.log(candidateSkillSelected)
//         //             console.log(candidateOtherSkills)
//         //         getRequest(`master/getSkillMaster`)
//         //    .then(res=>{
//         //         console.log(res);
//         //     if(res.data.responseStatus.statusCode ===0 ){
//         //         return dispatch({
//         //             type:actionTypes.GET_SKILLS_SUCCESS,
//         //             payload :res.data.responseData.skillList,
//         //         })
//         //     }
//         //     else{
//         //         return dispatch({
//         //             type:actionTypes.GET_SKILLS_FAIL,
//         //             payload :res.data.responseData.message
//         //         })
//         //     }
//         //    })
//         //    .catch(error =>{
//         //     return dispatch({
//         //         type:actionTypes.GET_SKILLS_FAIL,
//         //         payload :"Server Error"
//         //     })
//         //    })
//                 return dispatch({
//                     type:actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_SUCCESS,
//                     payload : res.data.responseData.candidateProfileList
//                 })
//             }
//             else{
//                 return dispatch({
//                     type:actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_FAIL,
//                     payload :res.data.responseData.message
//                 })
//             }
//            })
//            .catch(error =>{
//             return dispatch({
//                 type:actionTypes.VIEW_SINGLE_CANDIDATE_PROFILE_FAIL,
//                 payload :"Server Error"
//             })
//            })
//     }
// }

//-------------------- API ARCHIVE CANDIDATE PROFILE - NIKHIL ------------------------------------------------------

//api for self assensment
export const getInterviewList = (page) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GETINTERVIEWLIST_INITIAL });
    getRequest(`employer/getInterviewList?page=${page}&limit=6`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GETINTERVIEWLIST_SUCCESS,
            interviewList: res.data.responseData.interviewList,
            pagination: res.data.responseData.commonPaginationResponse,
          });
        } else {
          return dispatch({
            type: actionTypes.GETINTERVIEWLIST_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.GETINTERVIEWLIST_NETWORK_ERROR,
        });
      });
  };
};
//api for self assensment
export const getCandidateProfile = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CANDIDATE_PROFILE_INITIAL });
    dispatch({ type: actionTypes.UPDATED_NAME_INITIAL });
    dispatch({ type: actionTypes.UPDATED_OTP_INITIAL });
    getRequest("candidate/getCandidateProfile")
      .then((res) => {
        dispatch({
          type: actionTypes.GET_CANDIDATE_PROFILE_SUCCESS,
          payload: res.data.responseData,
        });
      })
      .catch((e) => {});
  };
};

//Api getDashboardDetails Brijesh start
export const getDashboardDetails = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GETDASHBOARDDETAILS_INITIAL });
    getRequest("employer/getDashBoardDetails")
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GETDASHBOARDDETAILS_SUCCESS,
            dashBoardList: res.data.responseData.dashBoardPojoList,
            dashBoardPagination: res.data.responseData.commonPaginationResponse,
          });
        } else {
          return dispatch({
            type: actionTypes.GETDASHBOARDDETAILS_FAIL,
            dashBoarderrorMsg: res.data.responseData,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.GETDASHBOARDDETAILS_NETWORK_ERROR,
        });
      });
  };
};

//--------------------API SCHEDULE INTERVIEW JOB PROFILE LISTING ATISHAY 28-Aug-------------------------------------------------------------------------

export const getScheduleProfileList = (page, searchItem) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_JOB_PROFILE_INITIAL });
    postRequest(`employer/viewJobProfile?page=${page}&limit=6`, {
      searchByJobTitleOrSkill: searchItem,
    })
      .then((res) => {
        const record =
          res.data.responseData.commonPaginationResponse == undefined
            ? 0
            : res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit;
        if (res.data.responseData.jobProfileDetails == undefined) {
          return dispatch({
            type: actionTypes.GET_JOB_PROFILE_FAIL,
            payload: false,
            nodata: true,
          });
        }
        const newArr = res.data.responseData.jobProfileDetails.map(
          (element) => {
            return {
              jobTitle: element.jobTitle,
              id: element.id,
              created: element.created,
              clientName: element.clientName,
              maxExperience: element.maxExperience,
              minExperience: element.minExperience,
              mustHaveJobSkills:
                element.mustHaveJobSkills !== null
                  ? element.mustHaveJobSkills
                  : [],
              otherMustHaveSkills:
                element.otherMustHaveSkills !== null
                  ? element.otherMustHaveSkills
                  : [],
              otherPreferredSkills:
                element.otherPreferredSkills !== null
                  ? element.otherPreferredSkills
                  : [],
              preferredJobSkills:
                element.preferredJobSkills !== null
                  ? element.preferredJobSkills
                  : [],
              allJobSkillsWithPreecedence:
                element.allJobSkillsWithPreecedence !== null
                  ? element.allJobSkillsWithPreecedence
                  : [],
            };
          }
        );
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_JOB_PROFILE_SUCCESS,
            payload: newArr,
            records: record,
            companyName: res.data.responseData.companyName,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_JOB_PROFILE_FAIL,
            payload: false,
            nodata: true,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_JOB_PROFILE_FAIL,
          payload: true,
          nodata: true,
        });
      });
  };
};

//-------------------- API SEARCH SCHEDULE JOB PROFILE ------------------------------------------------------
export const searchScheduleJobProfile = (searchArray, page) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_JOB_PROFILE_INITIAL });
    postRequest(`employer/viewJobProfile?page=${page}&limit=6`, {
      searchByJobTitleOrSkill: searchArray,
    })
      .then((res) => {
        const record =
          res.data.responseData.commonPaginationResponse == undefined
            ? 0
            : res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit;
        if (res.data.responseData.jobProfileDetails == undefined) {
          return dispatch({
            type: actionTypes.SEARCH_SCHEDULE_JOB_PROFILE_EMPTY,
          });
        }
        const newArr = res.data.responseData.jobProfileDetails.map(
          (element) => {
            return {
              jobTitle: element.jobTitle,
              id: element.id,
              created: element.created,
              clientName: element.clientName,
              maxExperience: element.maxExperience,
              minExperience: element.minExperience,
              mustHaveJobSkills:
                element.mustHaveJobSkills !== null
                  ? element.mustHaveJobSkills
                  : [],
              otherMustHaveSkills:
                element.otherMustHaveSkills !== null
                  ? element.otherMustHaveSkills
                  : [],
              otherPreferredSkills:
                element.otherPreferredSkills !== null
                  ? element.otherPreferredSkills
                  : [],
              preferredJobSkills:
                element.preferredJobSkills !== null
                  ? element.preferredJobSkills
                  : [],
              allJobSkillsWithPreecedence:
                element.allJobSkillsWithPreecedence !== null
                  ? element.allJobSkillsWithPreecedence
                  : [],
            };
          }
        );

        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_JOB_PROFILE_SUCCESS,
            payload: newArr,
            records: record,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_JOB_PROFILE_FAIL,
            payload: false,
            nodata: true,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_JOB_PROFILE_FAIL,
          payload: true,
          nodata: false,
        });
      });
  };
};

//--------------------API SCHEDULE INTERVIEW Candidate LISTING ATISHAY-------------------------------------------------------------------------

export const getScheduleCandidateList = (page, searchItem) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CANDIDATE_PROFILE_INITIAL });
    postRequest(`employer/viewCandidateProfile?page=${page}&limit=6`, {
      searchByCandidateNameOrSkill: [],
    })
      .then((res) => {
        const record =
          res.data.responseData.commonPaginationResponse == undefined
            ? 0
            : res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit;
        if (res.data.responseData.candidateProfileList == undefined) {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_PROFILE_FAIL,
            payload: false,
            nodata: true,
          });
        }
        const newArr =
          res.data.responseData.candidateProfileList == undefined
            ? []
            : res.data.responseData.candidateProfileList.map((element) => {
                return {
                  name: element.name,
                  id: element.id,
                  created: element.created,
                  experienceInYears: element.experienceInYears,
                  experienceInMonths: element.experienceInMonths,
                  candidateSkills:
                    element.candidateSkills !== null
                      ? element.candidateSkills
                      : [],
                  candidateOtherSkills:
                    element.candidateOtherSkills !== null
                      ? element.candidateOtherSkills
                      : [],
                  allSkillByOrder:
                    element.allSkillByOrder !== null
                      ? element.allSkillByOrder
                      : [],
                  feedback: element.feedback,
                  email: element.email,
                  mobile1: element.mobile1,
                  mobile2: element.mobile2,
                  mobileCountryCode1: element.mobileCountryCode1,
                  mobileCountryCode_2: element.mobileCountryCode_2,
                };
              });
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_PROFILE_SUCCESS,
            payload: newArr,
            SchedulecandidateRecords: record,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_PROFILE_FAIL,
            payload: true,
            nodata: false,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_CANDIDATE_PROFILE_FAIL,
          payload: false,
          nodata: true,
        });
      });
  };
};

//-------------------- API SEARCH SCHEDULE CANDIDATE PROFILE  ------------------------------------------------------
export const searchScheduleCandidateProfile = (searchArray) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CANDIDATE_PROFILE_INITIAL });
    postRequest(`employer/viewCandidateProfile?limit=6`, {
      searchByCandidateNameOrSkill: searchArray,
    })
      .then((res) => {
        const record =
          res.data.responseData.commonPaginationResponse == undefined
            ? 0
            : res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit;
        if (res.data.responseData.candidateProfileList == undefined) {
          return dispatch({
            type: actionTypes.SEARCH_SCHEDULE_CANDIDATE_PROFILE_EMPTY,
          });
        }
        const newArr = res.data.responseData.candidateProfileList.map(
          (element) => {
            return {
              name: element.name,
              id: element.id,
              created: element.created,
              experienceInYears: element.experienceInYears,
              experienceInMonths: element.experienceInMonths,
              candidateSkills:
                element.candidateSkills !== null ? element.candidateSkills : [],
              candidateOtherSkills:
                element.candidateOtherSkills !== null
                  ? element.candidateOtherSkills
                  : [],
              allSkillByOrder:
                element.allSkillByOrder !== null ? element.allSkillByOrder : [],
              feedback: element.feedback,
              email: element.email,
              mobile1: element.mobile1,
              mobile2: element.mobile2,
              mobileCountryCode1: element.mobileCountryCode1,
              mobileCountryCode_2: element.mobileCountryCode_2,
            };
          }
        );

        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_PROFILE_SUCCESS,
            payload: newArr,
            SchedulecandidateRecords: record,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_PROFILE_FAIL,
            payload: false,
            nodata: true,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_CANDIDATE_PROFILE_FAIL,
          payload: true,
          nodata: false,
        });
      });
  };
};

//--------------------API SCHEDULE INTERVIEW Interviewer LISTING ATISHAY-------------------------------------------------------------------------

export const getScheduleInterviwerList = (page, data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_INTERVIEWER_PROFILE_INITIAL });
    //console.log('trying')
    postRequest(`employer/getInterviewersByFilter?page=${page}&limit=6`, data)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_PROFILE_SUCCESS,
            payload: res.data.responseData.interviewerList,
            records:
              res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_PROFILE_FAIL,
            payload: "No Data Found",
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_INTERVIEWER_PROFILE_FAIL,
          payload: "Server Error",
        });
      });
  };
};

//Api getExternalInterviewerList Brijesh start

export const getExtInterviewerList = (page, searchArray, skillArray) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_EXT_INTERVIEWER_LIST_INITIAL });
    postRequest(`employer/getInterviewerList?page=${page}&limit=9`, {
      interviewerNameOrDomain: searchArray,
      skillIdList: skillArray,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          getRequest(`master/getSkillMaster`)
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                return dispatch({
                  type: actionTypes.GET_SKILLS_SUCCESS,
                  payload: res.data.responseData.skillList,
                });
              } else {
                return dispatch({
                  type: actionTypes.GET_SKILLS_FAIL,
                  payload: res.data.responseData.message,
                });
              }
            })
            .catch((error) => {
              return dispatch({
                type: actionTypes.GET_SKILLS_FAIL,
                payload: "Server Error",
              });
            });
          return dispatch({
            type: actionTypes.GET_EXT_INTERVIEWER_LIST_SUCCESS,
            ExtinterviewerList: res.data.responseData.interviewerList,
            Extpagination:
              res.data.responseData.commonPaginationResponse
                .totalNumberOfPagesAsPerGivenPageLimit,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_EXT_INTERVIEWER_LIST_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_EXT_INTERVIEWER_LIST_NETWORK_ERROR,
        });
      });
  };
};

/*--------------SCHEDULE INTERVIEW STEP 4 ATISHAY START---------------*/

export const scheduleInterview = (formData) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_INITIAL });
    postRequest("candidate/scheduleInterview", formData)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_SUCCESS,
            payload: true,
          });
        } else {
          if (res.data.responseData.errorCode == "190") {
            return dispatch({
              type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_FAIL,
              payload:
                "Interviewer time slot is already booked. Please select another time slot.",
            });
          } else {
            return dispatch({
              type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_FAIL,
              payload: "The transaction is failed. Kindly repeat the payment.",
            });
          }
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_ERROR,
          payload: "Unable to schedule Interview. Try Again",
        });
      });
  };
};

export const scheduleCounselling = (currentPage, formData) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.SCHEDULE_COUNCELLING_INITIAL });

    postRequest("candidate/scheduleCounselling", formData)
      .then((res) => {
        console.log("ressss", res);

        if (res.data.responseData.sessionScheduled === true) {
          console.log("reeee", res);
          dispatch({
            type: actionTypes.SCHEDULE_COUNCELLING_SUCCESS,
            payload: true,
          });
        } else {
          console.log("reeeeaaa", res);
          const errorMessage =
            res.data.responseData.sessionScheduled === false
              ? "Interviewer time slot is already booked. Please select another time slot."
              : "The transaction is failed. Kindly repeat the payment.";

          dispatch({
            type: actionTypes.SCHEDULE_COUNCELLING_FAIL,
            payload: errorMessage,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.SCHEDULE_COUNCELLING_ERROR,
          payload: "Unable to schedule Interview. Try Again",
        });
      });
  };
};

export const scheduleInterviewResetState = () => {
  return (dispatch) => {
    return dispatch({
      type: actionTypes.SCHEDULE_INTERVIEW_PROFILE_RESET_STATE,
    });
  };
};
/*--------------SCHEDULE INTERVIEW STEP 4 ATISHAY ENDS---------------*/

//Api getInterviewerProfile Brijesh start
export const getInterviewerProfile = (email, id) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_INITIAL });
    getRequest(`employer/getInterviewerProfile?interviewerId=${id}`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          getRequest(`file/downloadFile?entityId=${id}&entityType=IN`)
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                return dispatch({
                  type: actionTypes.OPEN_CV_SUCCESS,
                  cvData: res.data.responseData.presignedUrlForDownload,
                });
              } else {
                return dispatch({
                  type: actionTypes.OPEN_CV_FAIL,
                  openCvErrorMsg: res.data.responseData.errorType,
                  suggestion: res.data.responseData.message,
                });
              }
            })
            .catch((err) => {
              return dispatch({
                type: actionTypes.OPEN_CV_NETWORK_ERROR,
              });
            });
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS,
            interviewerProfileData: res.data.responseData,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR,
        });
      });
  };
};

//Api saveIntervieweRating Brijesh start
export const saveInterviewerRating = (email, rating, id, name, skillId) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.SAVE_INTERVIEWER_RATING_INITIAL });
    postRequest("employer/saveInterviewerRating", {
      interviewerEmail: email,
      rating: rating,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          postRequest(`employer/getInterviewerList?page=1&limit=9`, {
            interviewerNameOrDomain: name,
            skillIdList: skillId,
          })
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                return dispatch({
                  type: actionTypes.GET_EXT_INTERVIEWER_LIST_SUCCESS,
                  ExtinterviewerList: res.data.responseData.interviewerList,
                  Extpagination:
                    res.data.responseData.commonPaginationResponse
                      .totalNumberOfPagesAsPerGivenPageLimit,
                });
              } else {
                return dispatch({
                  type: actionTypes.GET_EXT_INTERVIEWER_LIST_FAIL,
                  payload: res.data.responseData.message,
                });
              }
            })
            .catch((err) => {
              return dispatch({
                type: actionTypes.GET_EXT_INTERVIEWER_LIST_NETWORK_ERROR,
              });
            });
          //    this.getInterviewerProfile(email,id);
          getRequest(`employer/getInterviewerProfile?interviewerEmail=${email}`)
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                getRequest(`file/downloadFile?entityId=${id}&entityType=IN`)
                  .then((res) => {
                    if (res.data.responseStatus.statusCode === 0) {
                      return dispatch({
                        type: actionTypes.OPEN_CV_SUCCESS,
                        cvData: res.data.responseData.presignedUrlForDownload,
                      });
                    } else {
                      return dispatch({
                        type: actionTypes.OPEN_CV_FAIL,
                        openCvErrorMsg: res.data.responseData.errorType,
                        suggestion: res.data.responseData.message,
                      });
                    }
                  })
                  .catch((err) => {
                    return dispatch({
                      type: actionTypes.OPEN_CV_NETWORK_ERROR,
                    });
                  });
                return dispatch({
                  type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_SUCCESS,
                  interviewerProfileData: res.data.responseData,
                });
              } else {
                return dispatch({
                  type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_FAIL,
                  payload: res.data.responseData.message,
                });
              }
            })
            .catch((err) => {
              return dispatch({
                type: actionTypes.GET_INTERVIEWER_PROFILE_BRIJESH_NETWORK_ERROR,
              });
            });
          return dispatch({
            type: actionTypes.SAVE_INTERVIEWER_RATING_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.SAVE_INTERVIEWER_RATING_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.SAVE_INTERVIEWER_RATING_NETWORK_ERROR,
        });
      });
  };
};

/*--------------GET CANDIDATE FEEDBACK - NIKHIL---------------*/

export const getCandidateFeedback = (id) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CANDIDATE_FEEDBACK_INITIAL });
    getRequest(`employer/getInterviewFeedback/${id}`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          console.log("feedback");
          return dispatch({
            type: actionTypes.GET_CANDIDATE_FEEDBACK_SUCCESS,
            payload: res.data.responseData,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_CANDIDATE_FEEDBACK_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.GET_CANDIDATE_FEEDBACK_FAIL,
          payload: err.message,
        });
      });
  };
};

export const getFeedBackErrorFalse = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_CANDIDATE_FEEDBACK_ERROR_FALSE });
  };
};

// ----------------CANDIDATE DOWNLOAD FILE - NIKHIL-----------------------------

export const candidateDownloadFile = (id) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CANDIDATE_DOWNLOAD_FILE_INITIAL });
    getRequest(`file/downloadFile?entityId=${id}&entityType=CN`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.CANDIDATE_DOWNLOAD_FILE_SUCCESS,
            cvData: res.data.responseData.presignedUrlForDownload,
          });
        } else {
          return dispatch({
            type: actionTypes.CANDIDATE_DOWNLOAD_FILE_FAIL,
            openCvErrorMsg: res.data.responseData.errorType,
            suggestion: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.CANDIDATE_DOWNLOAD_FILE_FAIL,
          payload: err.message,
        });
      });
  };
};

// ----------------CANDIDATE DOWNLOAD FILE - Atishay-----------------------------

export const candidateDownloadFileSchedule = (id) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CANDIDATE_DOWNLOAD_FILE_INITIAL });
    getRequest(`file/downloadFile?entityId=${id}&entityType=CN`)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          window.open(res.data.responseData.presignedUrlForDownload, "_blank");
          return dispatch({
            type: actionTypes.CANDIDATE_DOWNLOAD_FILE_SUCCESS,
            cvData: res.data.responseData.presignedUrlForDownload,
          });
        } else {
          return dispatch({
            type: actionTypes.CANDIDATE_DOWNLOAD_FILE_FAIL,
            openCvErrorMsg: res.data.responseData.errorType,
            suggestion: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.CANDIDATE_DOWNLOAD_FILE_FAIL,
          payload: err.message,
        });
      });
  };
};

//--------------------API GET INTERVIEWER FORGOT PASSWORD RESET  BRIJESH-------------------------------------------------------------------------

export const interviewerForgotPassword = (email) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.INTERVIEWER_FORGOT_PASSWORD_INITIAL });
    postRequest("candidate/forgetPasswordEmail", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.INTERVIEWER_FORGOT_PASSWORD_SUCCESS,
            email: email,
          });
        } else {
          return dispatch({
            type: actionTypes.INTERVIEWER_FORGOT_PASSWORD_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.INTERVIEWER_FORGOT_PASSWORD_NETWORK_ERROR,
        });
      });
  };
};

//Interviewer Reset password(updatingNewPassword) brijesh

export const updatingNewPassword = (pass, confirm, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESET_PASSWORD_INITIAL });
    postResetPass(`candidate/updatePassword?token=${token}`, {
      confirmPassword: confirm,
      password: pass,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.RESET_PASSWORD_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {});
  };
};

//Resend Otp from Login

export const resendOTP = (email) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESEND_OTP_INITIAL });
    postResetPass("candidate/resendOTP", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESEND_OTP_SUCCESS,
            otpresponse: res.data.responseData.otpSent,
            mobileLastFourDigit: res.data.responseData.mobileLastFourDigit,
          });
        } else {
          return dispatch({
            type: actionTypes.RESEND_OTP_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.RESEND_OTP_NETWORK_ERROR,
        });
      });
  };
};

//veridy Otp Brijesh start
export const verifyOtpAtlogin = (email, otp) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.VERIFY_OTP_AT_LOGIN_INITIAL });
    postRequestVerify("candidate/verifyOTP", {
      email: email,
      otp: otp,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.VERIFY_OTP_AT_LOGIN_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.VERIFY_OTP_AT_LOGIN_FAIL,
            verifyerrmsg: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.VERIFY_OTP_AT_LOGIN_NETWORK_ERROR,
        });
      });
  };
};
export const clearLoginState = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_LOGIN_STATE,
    });
  };
};
// export const resetOtpScreen=()=>{
//     return dispatch=>{
//         dispatch({
//             type:actionTypes.VERIFY_OTP_RESET_STATE
//         })
//     }
// }

//Resend Interviewer Email brijesh
//veridy Otp Brijesh start
export const resendInterviewerEmail = (email) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.RESEND_INTERVIEWER_EMAIL_INITIAL });
    postRequestVerify("interviewer/resendInterviewerEmail", {
      email: email,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.RESEND_INTERVIEWER_EMAIL_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.RESEND_INTERVIEWER_EMAIL_FAIL,
            verifyerrmsg: res.data.responseData.message,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.RESEND_INTERVIEWER_EMAIL_NETWORK_ERROR,
        });
      });
  };
};

// Employer Cancel Interview API

export const employerCancelInterview = (id, reason, page) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.EMPLOYER_CANCEL_INTERVIEW_INITIATE });
    postRequest("employer/cancelInterview", {
      interviewId: id,
      reason: reason,
      userType: 0,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          dispatch({ type: actionTypes.CREDIT_BALANCE_INITIAL });
          getRequest("candidate/candidateCreditBalance", {}).then((res) => {
            if (res.data.responseStatus.statusCode === 0) {
              return dispatch({
                type: actionTypes.CREDIT_BALANCE_SUCCESS,
                payload: res.data.responseData.creditBalance,
              });
            } else {
              return dispatch({
                type: actionTypes.CREDIT_BALANCE_FAIL,
                payload: res.data.responseData,
              });
            }
          });

          getRequest(`employer/getInterviewList?page=${page}&limit=6`)
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                return dispatch({
                  type: actionTypes.GETINTERVIEWLIST_SUCCESS,
                  interviewList: res.data.responseData.interviewList,
                  pagination: res.data.responseData.commonPaginationResponse,
                });
              } else {
                return dispatch({
                  type: actionTypes.GETINTERVIEWLIST_FAIL,
                  payload: res.data.responseData.message,
                });
              }
            })
            .then((res) => {
              return dispatch({
                type: actionTypes.EMPLOYER_CANCEL_INTERVIEW_SUCCESS,
              });
            });
        } else {
          return dispatch({
            type: actionTypes.EMPLOYER_CANCEL_INTERVIEW_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.EMPLOYER_CANCEL_INTERVIEW_NETWORK_ERROR,
          payload: true,
        });
      });
  };
};

// Check Interview Schedule Balance -------------Nikhil

export const checkInterviewScheduleBalance = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_INITIATE });
    postRequest("employer/checkInterviewScheduleBalance")
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_SUCCESS,
            payload: res.data.responseData,
          });
        } else {
          return dispatch({
            type: actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_FAIL,
            payload: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.CHECK_INTERVIEW_SCHEDULE_BALANCE_NETWORK_ERROR,
        });
      });
  };
};

//Api GET_INTERVIEWER_AVAILABLE_SLOT ATISHAY start
export const getInterviewerAvailableSlot = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_INITIATE });
    postRequest("employer/getInterviewerAndCandidateInterviewByDate", data)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_SUCCESS,
            interviewerInterviewByDate:
              res.data.responseData.interviewerInterviewByDate,
            candidateInterviewByDate:
              res.data.responseData.candidateInterviewByDate,
            candidateName: res.data.responseData.candidateName,
            interviewerName: res.data.responseData.interviewerName,
          });
        } else {
          return dispatch({
            type: actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_FAIL,
            availableSlotError: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.GET_INTERVIEWER_AVAILABLE_SLOTS_NETWORK_ERROR,
        });
      });
  };
};
//brijesh new save rating
export const newsaveInterviewerRating = (id, email, rating, page) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.NEW_SAVE_INTERVIEWER_RATING_INITIATE });
    postRequest("employer/saveInterviewerRating", {
      interviewId: id,
      interviewerEmail: email,
      rating: rating,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          dispatch({ type: actionTypes.GETINTERVIEWLIST_INITIAL });
          getRequest(`employer/getInterviewList?page=${page}&limit=6`)
            .then((res) => {
              if (res.data.responseStatus.statusCode === 0) {
                return dispatch({
                  type: actionTypes.GETINTERVIEWLIST_SUCCESS,
                  interviewList: res.data.responseData.interviewList,
                  pagination: res.data.responseData.commonPaginationResponse,
                });
              } else {
                return dispatch({
                  type: actionTypes.GETINTERVIEWLIST_FAIL,
                  payload: res.data.responseData.message,
                });
              }
            })
            .catch((error) => {
              return dispatch({
                type: actionTypes.GETINTERVIEWLIST_NETWORK_ERROR,
              });
            });

          return dispatch({
            type: actionTypes.NEW_SAVE_INTERVIEWER_RATING_SUCCESS,
          });
        } else {
          return dispatch({
            type: actionTypes.NEW_SAVE_INTERVIEWER_RATING_FAIL,
            payload: null,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.NEW_SAVE_INTERVIEWER_RATING_NETWORK_ERROR,
        });
      });
  };
};

/*--------------Notify FoxMatrix API ATISHAY START---------------*/

export const notifyFoxmatrix = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.NOTIFY_FOXMATRIX_INITIATE });
    postRequest("employer/employerSearch", {
      jobId: data[0],
      searchValue: data[1],
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.NOTIFY_FOXMATRIX_SUCCESS,
            payload: true,
          });
        } else {
          return dispatch({
            type: actionTypes.NOTIFY_FOXMATRIX_FAIL,
            payload: true,
          });
        }
      })
      .catch((err) => {
        return dispatch({
          type: actionTypes.NOTIFY_FOXMATRIX_NETWORK_ERROR,
          payload: err,
        });
      });
  };
};
/*--------------Notify FoxMatrix API ATISHAY ENDS---------------*/

/*--------------Notify Clear State Start------------------------------ */
export const clearStateNotify = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CLEAR_STATE_NOTIFY });
  };
};
/*--------------Notify Clear State ENds------------------------------ */

export const viewInterviewDetails = (id) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.VIEW_INTERVIEW_DETAILS_INITIATE });
    postRequest("employer/getInterviewPreviewDetails", {
      interviewId: id,
    })
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.VIEW_INTERVIEW_DETAILS_SUCCESS,
            viewInterviewDetailsData: res.data.responseData,
          });
        } else {
          return dispatch({
            type: actionTypes.VIEW_INTERVIEW_DETAILS_FAIL,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        return dispatch({
          type: actionTypes.VIEW_INTERVIEW_DETAILS_NETWORK_ERROR,
        });
      });
  };
};

// employer/checkInterviewTime

export const checkinterviewtime = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CHECK_INTERVIEW_TIME_INITIATE });
    postRequest("employer/checkInterviewTime", data)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.CHECK_INTERVIEW_TIME_SUCCESS,
            status: res.data.responseData,
          });
        } else {
          return dispatch({
            type: actionTypes.CHECK_INTERVIEW_TIME_FAIL,
            message: res.data.responseData.message,
          });
        }
      })
      .catch((error) => {
        return dispatch({
          type: actionTypes.CHECK_INTERVIEW_TIME_NETWORK_ERROR,
        });
      });
  };
};

export const getCreditBalance = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CREDIT_BALANCE_INITIAL });
    getRequest("candidate/candidateCreditBalance", {})
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          return dispatch({
            type: actionTypes.CREDIT_BALANCE_SUCCESS,
            payload: res.data.responseData.creditBalance,
          });
        } else {
          return dispatch({
            type: actionTypes.CREDIT_BALANCE_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};

export const postHelpFeedback = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.HELP_AND_FEEDBACK_INITIATE });
    postRequest(`support/helpOrFeedback`, data)
      .then((res) => {
        if (res.data.responseStatus.statusCode === 0) {
          dispatch({
            type: actionTypes.HELP_AND_FEEDBACK_SUCCESS,
            payload: res.data.responseData.success,
          });
        } else {
          dispatch({
            type: actionTypes.HELP_AND_FEEDBACK_FAIL,
            payload: res.data.responseData,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.HELP_AND_FEEDBACK_NETWORKERROR,
        });
      });
  };
};
